import type { TuPart, TuPartAuthor } from "../../hooks/use-tu-parts";
import dayjs from "dayjs";

export type TuPartRow = TuPart & {
  fileName?: string | null;
  baseName?: string | null;
  ext?: string | null;
  createdAt?: string | null;
  authorId?: string | null;
  authorName?: string | null;
};

export type TuPartTableContext = {
  canUpload: boolean;
  canDelete: boolean;
  onDownload: (part: TuPartRow) => void;
  onDelete: (part: TuPartRow) => void;
  onUpload: (part: TuPartRow) => void;
};

export const formatUploadDate = (value?: string | null): string => (value ? dayjs(value).format("DD.MM.YYYY, HH:mm") : "—");

export type { TuPartAuthor };
